"use client"
import { useState, useEffect } from "react";
import { useParams } from "next/navigation";


import { getCookies } from "@/utils/frontend/cookieOps";

import { GrayButton, IndigoButton, TealButton } from "@/components/Atoms/Buttons/ColorButtons";
import { useContext } from "react";
import { UIContext } from "@/contexts/UIContext";
import NotificationSmallCard from "../Cards/NotificationSmallCard";


const NotificationsModal = ({
  displayMode = 'APP_NOTIFICATIONS', // can also be CHAT_NOTIFICATIONS
  data,
  lang,
  callback,
  state,
  modalHeaderCaption,
  user,
}) => {

  const { supportModalOpen, setSupportModalOpen, sideNavbarPinned, setSideNavbarPinned } = useContext(UIContext);

  // const user = getCookies().user

  // const [showModal, setShowModal] = useState(false);
  const [postData, setPostData] = useState({})
  const [bulletinsTableArray, setBulletinsTableArray] = useState([])

  const [apiTags, setApiTags] = useState()
  const [error, setError] = useState(false)
  const [success, setSuccess] = useState(false)
  const [showSuccessAlert, setShowSuccessAlert] = useState(false)
  const [showErrorAlert, setShowErrorAlert] = useState(false)
  const [tagsTableArray, setTagsTableArray] = useState()
  const [tagEditorModalOpen, setTagEditorModalOpen] = useState(false)
  const [targetTag, setTargetTag] = useState()
  const [tagColors, setTagColors] = useState()
  const [existingTags, setExistingTags] = useState([])
  const [tagDeleteModalOpen, setTagDeleteModalOpen] = useState(false)
  const [loading, setLoading] = useState(false)

  // const [bulletinContent, setBulletinContent] = useState(null)



  // const getData = async () => {
  //   try {
       
  //     // let apiUrl = target ? `/api/jobs/?id=${target.id}` : `/api/jobs/`
  //     let apiUrl = `/api/bulletins/`
  //     let response = await fetch(apiUrl, {
  //     //  method: `${target ? 'PUT' : 'POST'}`, // Use uppercase for HTTP methods
  //     method: 'GET',
  //      headers: {
  //        'Accept': '*/*',
  //        'Content-Type': 'application/json'
  //      },
  //      credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
     
  //     // body: data
  //    });

  //    response = await response.json()
  //   //  console.log(response)
  //    let bulletins = response.data;
  //    setBulletinsTableArray(bulletins.reverse())
  //    let existingTagsArray = []
  //   //   tags.forEach(tag => {
  //   //      let obj = {id: tag.id, value: tag.tag_name, label: tag.tag_name, tag_type: tag.tag_type}
  //   //      // array.push(obj)
  //   //      existingTagsArray.push(tag.tag_name)
  //   // });
  //   setLoading(false)
  //   setExistingTags(existingTagsArray);
        
  //   } catch (error) {
  //     console.log('error', error)
  //     // setError(error)
  //     setExistingTags([]);
  //   }


  // }
  
  useEffect(() => {
    setPostData({...postData, source_url: window.location.href})
  // getData()
  }, [])


  const handleClick = async (tag, action) => {
    console.log(tag)
    if (action === 'edit') { 
      setTargetTag({tag_id: tag.id, tag_name: tag.tag_name, tag_colors: tag.tag_colors, tag_type: tag.tag_type}); 
      setTagEditorModalOpen(true)
    }
    else if (action === 'delete') {
      setTargetTag({tag_id: tag.id, tag_name: tag.tag_name, tag_colors: tag.tag_colors, tag_type: tag.tag_type}); 
      setTagDeleteModalOpen(true)

    }
  }


  // const navigate = useNavigate();
  const { id } = useParams(); // get person / job / company ID based on current page id where component is called





  const handleSubmit = async () => {
    setLoading(true)
    if (!postData.email_body || postData.email_body.length < 10) {
      state.setError({message: lang === 'fr' ? 'Votre message est trop court.' : 'Your message is too short.'})
      setLoading(false)
      return false;
    }
      try { 
        let apiUrl = `/api/services/emails`
        let response = await fetch(apiUrl, {   
        method: 'POST',
         headers: {
           'Accept': '*/*',
           'Content-Type': 'application/json'
         },
         credentials: 'include', // If you are sending cookies with a cross-origin request, use 'include'
         body: JSON.stringify({data: postData, user: user}), // Convert the credentials object to a JSON string
       });

       response = await response.json()
       console.log(response)
       setPostData({...postData, email_body: ''})
       setLoading(false)
       state.setNotificationsModalOpen(false)
       state.setSuccess({message: lang === 'fr' ? "Votre requête à été envoyée" : 'Your request has been sent'})
      } catch (error) {
        console.log('error', error)
        state.setError({message: lang === 'fr' ? "Votre requête n'a pas pu être envoyée" : `Your request could not be sent\n${error}`})
        setLoading(false)
      }


  };



  // const handleChildCallback =  (callback)=>{
  //   console.log('cb', callback)
    
  //   if (callback.tags !== undefined){
  //     const tagsData = callback.tags.map(obj=>({tag_name: obj.value, tag_type: "PRIMARY"}))
  //     setData(tagsData)
  //   }

  //   if (callback.error) { setError(callback.error) }
  //   if (callback.success) { setSuccess(callback.success) }

  //   // if (callback.allTags) {setTagList(callback.allTags.reverse());}
  //   // if (callback.tagEditorModalOpen === false){setTagEditorModalOpen(false)}

  //   if (callback.tagColors && callback.tagColors.id) {setTagColors({colors: callback.tagColors.colors, id:callback.tagColors.id})}
  //   if (callback.refreshTable===true){setTimeout(() => {getData() }, 50);}
  //   if (callback.tagDeleteModalOpen === false) {setTagDeleteModalOpen(false); }

  // }

  // const handleCheckBox = (checked, target) => {
  //   console.log('checked, target', checked, target)
  //   setData({...data, bulletin_target_pages: {...data?.bulletin_target_pages, [target]: checked}})
  //   console.log(data)
  // }

  return (
<>





<div className="">
     {/* slide from bottom up */}
{/* <div
  className={`overflow-y-scroll no-scrollbar fixed min-h-96 h-5/6 text-sm rounded-xl shadow-2xl z-20 ${sideNavbarPinned ? 'left-64' : 'left-24'}  w-4/5 md:w-4/6 lg:w-2/6 bg-slate-50 dark:bg-slate-900 border-gray-300 dark:border-gray-700 text-black dark:text-white transition-all duration-300 transform ${state.notificationsModalOpen ? 'translate-y-0 bottom-3' : 'translate-y-full bottom-0'}`}
> */}
{/* slide from right to left */}
<div
// h-[calc(100vh-64px)]
  className={`overflow-y-scroll no-scrollbar fixed min-h-96 h-full text-sm border-l border-l-slate-200 z-50 right-0 w-4/5 md:w-4/6 lg:w-2/6 bg-slate-50 dark:bg-slate-900 border-gray-300 dark:border-gray-700 text-black dark:text-white transition-all duration-300 transform ${state.notificationsModalOpen || state.chatNotificationsModalOpen ? 'translate-x-0 bottom-0' : 'translate-x-full bottom-0'}`}
>

{/* HEADER */}
  <div className="flex items-center font-medium sticky top-0 bg-slate-50 dark:bg-slate-900 p-4 z-10">
    {/* Close Button on the Left */}
    <button
      onClick={() => {
        displayMode === 'APP_NOTIFICATIONS' ? state.setNotificationsModalOpen(false) : state.setChatNotificationsModalOpen(false)
      }}
      type="button"
      className="transition duration-300 ease-in-out mr-4 bg-gray-100 hover:bg-gray-200 text-gray-500 dark:text-gray-400 focus:ring-gray-400 rounded-lg focus:ring-2 p-1.5 inline-flex items-center justify-center h-8 w-8 dark:bg-gray-800 dark:hover:bg-gray-700"
      aria-label="Close"
    >
      <span className="sr-only">Close</span>
      <svg
        className="w-3 h-3"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 14 14"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"
        />
      </svg>
    </button>

    {/* Text on the Right */}
    <div className="text-gray-600 dark:text-gray-200">
      {modalHeaderCaption}
    </div>
  </div>

  <br/>
  {/* CONTENT */}
  <div className="flex flex-col gap-2 px-4">
      {data.map( n=> {
       return (
          <div key={n.notification_uuid}>
            <NotificationSmallCard callback={cb=>callback(cb)} user={user} data={n} parentComponent={'NOTIFICATIONS_MODAL'}/>
          </div>
        )
      })}
  </div>
  {/* CONTENT END  */}




</div>
   </div>



</>

   
  );
};

export default NotificationsModal;



